import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { t } from "i18next";
import { useSelector } from "react-redux";

const AssociateTableUserCompany = ({ userData = [] }) => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <div className="w-1/3">
      <div className=" flex justify-between items-center pr-5">
        <h3 className="flex">
          {t("UsersAssociated")}
          <div
            className="w-6 h-6 mx-4 rounded-3xl"
            style={{ backgroundColor: `${colorPrimary}` }}
          >
            <small className="text-white flex justify-center">
              {userData?.length}
            </small>
          </div>
        </h3>
      </div>
      <div className="py-2 flex space-x-2"></div>
      <TableContainer component={Paper} elevation={1}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("Name")}</TableCell>
              <TableCell>{t("Surname")}</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>{t("Role")}</TableCell>
            </TableRow>
          </TableHead>

          {userData?.map((el) => (
            <TableRow className="hover:shadow-md" key={el.id}>
              <TableCell>{el.name}</TableCell>
              <TableCell>{el.surname}</TableCell>
              <TableCell>{el.email}</TableCell>
            </TableRow>
          ))}
        </Table>
        {userData?.length === 0 && (
          <p className="flex justify-center py-2 text-gray">{t("NoUsers")}</p>
        )}
      </TableContainer>
    </div>
  );
};

export default AssociateTableUserCompany;
